import { plugin, type TabProps } from 'light-component';
import * as Base from '@base';
import { t } from '@common';
import type { ReactElement } from 'react';

export function WidgetTab(props: TabProps): ReactElement {
  return (
    <div>
      <Base.Tabs activeKey={props.value} onChange={(key: string | null) => key != null && props.onSelect?.(key)}>
        {props.options.map(item => (
          <Base.Tabs.TabPane key={item.value} tab={t(item.title)} forceRender={true}>
            {item.children}
          </Base.Tabs.TabPane>
        ))}
      </Base.Tabs>
    </div>
  );
}
plugin.register({ kind: 'widget', type: 'tab', component: WidgetTab });
